import { RouteConfig } from 'react-router-config';
// import { Redirect } from 'react-router-dom';
import { DocumentDetail } from '../../pages/document';

export const DOCUMENT_ROUTE: RouteConfig[] = [
  {
    path: '/doc/detail/:projectId/:docId?',
    // component: DocumentDetail,
    render: () => <DocumentDetail isDocPublicRoute={false} />,
    // routes: [

    // ],
  },
  {
    path: '/doc-public/detail/:projectId/:docId?',
    render: () => <DocumentDetail isDocPublicRoute={true} />,
  },
];
